// Data for each skill category and items
export const skillsData = [
  {
    category: "Programming Languages",
    items: ["Python", "C++", "MATLAB"],
  },
  {
    category: "ML & Vision",
    items: ["PyTorch", "OpenCV", "NumPy", "CVAT", "YOLOv5"],
  },
  {
    category: "Robotics & Simulation",
    items: ["ROS 2", "Gazebo", "MuJoCo", "Simulink"],
  },
  {
    category: "Control Systems",
    items: ["Impedance Control", "LQR / LQG", "PID", "MPC", "Feedback Linearization"],
  },
  {
    category: "Design & CAD",
    items: ["Autodesk Fusion 360", "AutoCAD"],
  },
  {
    category: "Dev & Platforms",
    items: ["Linux", "VS Code", "Google Colab", "Jupyter"],
  },
];

// Data for achievements and certifications
export const achievementsData = [
  {
    title: "NITT Undergraduate STEM Research Fellowship",
    description:
      "Top Merit Award and ₹70,000 grant at NITT STEM Research Awards 2024 for a proposal on Adaptive RL-based Predictive Control of Autonomous Quadrotor Systems.",
  },
  {
    title: "Third Place — Genesis '23 Startup Competition",
    description:
      "Among 30 teams at the annual startup competition, Institution's Innovation Council, NIT Trichy.",
  },
  {
    title: "Reinforcement Learning",
    description:
      "NPTEL certified, IIT Madras. Instructor: Dr. B. Ravindran.",
  },
  {
    title: "Drone Systems and Control",
    description:
      "NPTEL certified, IISc Bangalore. Instructor: Dr. Suresh Sundaram.",
  },
];
